module.exports = __webpack_public_path__ + "img/SprayPainting2.937f5da8.jpg";